import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RefillAlertsCount {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RefillAlertsCountData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RefillAlertsCount = {
  isLoading: false,
  error: false,
  message: null,
  RefillAlertsCountData: [],
  Items: [],
  Pagination: [],
};

const RefillAlertsCountSlice = createSlice({
  name: "RefillAlertsCount",
  initialState,
  reducers: {
    loadingRefillAlertsCount: (
      state: RefillAlertsCount,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRefillAlertsCount: (
      state: any,
      action: PayloadAction<RefillAlertsCount>
    ) => {
      return action.payload;
    },
  },
});

export const { loadingRefillAlertsCount, setRefillAlertsCount } =
  RefillAlertsCountSlice.actions;
export default RefillAlertsCountSlice.reducer;
